import styled, { css } from 'styled-components'
import theme from 'theme_'
import { CommonLinkButton } from 'components/Button'

export const HomeServicesTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: calc(${theme.breakpoint.tablet}px - 16px);
  }
`

export const HomeServicesTableOuterWrapper = styled.div`
  @media ${theme.devices.tablet} {
    width: 100%;
    overflow-y: auto;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
    border-radius: 8px;
  }
`

export const HomeServicesComponentCell = styled.div`
  font-weight: 900;
  width: 100%;
`

export const HomeServicesActiveCellStyles = css`
  justify-content: flex-end;
`

export const HomeServicesTypeCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
`

export const HomeServicesRowStyles = css`
  height: auto;
  min-height: 40px;
  align-items: center;
`

export const ShowEventFormPopup = styled(CommonLinkButton)`
  display: flex;
  align-items: center;
`
